//onload form detail
export const HELP_DATA_DETAIL_BEFORE_LOGIN = "HELP_DATA_DETAIL_BEFORE_LOGIN"
export const HELP_DATA_DETAIL_BEFORE_LOGIN_SUCCESS = "HELP_DATA_DETAIL_BEFORE_LOGIN_SUCCESS"
export const HELP_DATA_DETAIL_BEFORE_LOGIN_API_ERROR = "HELP_DATA_DETAIL_BEFORE_LOGIN_API_ERROR"

//FAQ form submit
export const HELP_DATA_DETAIL_BEFORE_LOGIN_SUBMIT = "HELP_DATA_DETAIL_BEFORE_LOGIN_SUBMIT"
export const HELP_DATA_DETAIL_BEFORE_LOGIN_SUBMIT_SUCCESS = "HELP_DATA_DETAIL_BEFORE_LOGIN_SUBMIT_SUCCESS"
export const HELP_DATA_DETAIL_BEFORE_LOGIN_SUBMIT_API_ERROR = "HELP_DATA_DETAIL_BEFORE_LOGIN_SUBMIT_API_ERROR"